// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".activator-wrap[data-v-42cfca26]{height:100%}", ""]);
// Exports
module.exports = exports;
